module.exports = __webpack_public_path__ + "media/images/flags/32/Christmas-Island-1414e3a65826715a4f6f9cd9ae06ae9c.png";